import { createSlice } from '@reduxjs/toolkit';

import { fetchGrazingData, fetchGrazingHeatmapStyles } from '../actions/grazing';

const grazingSlice = createSlice({
  name: 'grazing',
  initialState: {
    data: null,
    error: null,
    loading: false,
    styles: null
  },
  extraReducers: builder => {
    builder
      // Fetch Grazing data
      .addCase(fetchGrazingData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGrazingData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchGrazingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Grazing heatmap styles
      .addCase(fetchGrazingHeatmapStyles.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGrazingHeatmapStyles.fulfilled, (state, action) => {
        state.styles = action.payload;
        state.loading = false;
      })
      .addCase(fetchGrazingHeatmapStyles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default grazingSlice.reducer;
